import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25484ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1))

import { computed } from "vue";

import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import { getPeriodName } from "@/services/utils/DateParser";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputInterval',
  props: ["modelValue", "disabled"],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const periodNames = computed(() => {
  return [
    { name: getPeriodName(props.modelValue.interval, "DAY"), code: "DAY" },
    { name: getPeriodName(props.modelValue.interval, "WEEK"), code: "WEEK" },
    { name: getPeriodName(props.modelValue.interval, "MONTH"), code: "MONTH" },
    { name: getPeriodName(props.modelValue.interval, "YEAR"), code: "YEAR" },
  ];
});

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputNumber), {
      modelValue: props.modelValue.interval,
      inputId: "horizontal-buttons",
      showButtons: "",
      buttonLayout: "horizontal",
      step: 1,
      min: 0,
      disabled: props.disabled,
      class: "fl-1 m-r-12 segment-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = 
      ($event) => {
        emit('update:modelValue', {interval: $event, unit: props.modelValue.unit});
      }
    )
    }, {
      incrementbuttonicon: _withCtx(() => [
        _hoisted_2
      ]),
      decrementbuttonicon: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createVNode(_unref(Dropdown), {
      modelValue: props.modelValue.unit,
      options: periodNames.value,
      optionLabel: "name",
      optionValue: "code",
      class: "fl-1",
      disabled: props.disabled,
      placeholder: "Дней",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = 
      ($event) => {
        emit('update:modelValue', {interval: props.modelValue.interval, unit: $event});
      }
    )
    }, null, 8, ["modelValue", "options", "disabled"])
  ]))
}
}

})